module.exports = __webpack_public_path__ + "img/PLUM_80X30.87a18a98.png";